<div class="processor">
    <div class="title centered-container">
        <h2>Project Creation / Column Mapping</h2>
    </div>
    <div class="centered-container" *ngIf="!loading && project && !service.errorMessage">
        <section class="project-section panel panel-default">
            <h4>Project Information</h4>
            <button class="icon inline btn btn-transparent" title="Help" (click)="toggleSpecificHelp('project')">
                <span class="icon icon-ui-question"></span>
            </button>
            <div class="project">
                <div class="project-name">
                    <label class="project-label">Project:</label>
                    <select class="form-control" *ngIf="!createProject" (change)="projectChanged()"
                        [(ngModel)]="project">
                        <option [ngValue]="p" *ngFor="let p of projectList">
                            {{ p.selectLabel }}
                        </option>
                    </select>
                    <input type="text" class="form-control description" *ngIf="createProject"
                        [(ngModel)]="project.description" [ngClass]="{'warning': !projectDescriptionIsValid}"
                        placeholder="Enter Project Name" />
                    <span class="new-project" *ngIf="projectList.length > 0">
                        <input type="checkbox" (change)="toggleNewProject()" [checked]="!createProject" /> Update?
                    </span>
                </div>
                <div class="days-left">
                    <label>Lifespan:</label>
                    <input type="number" class="form-control number lifespan" id="dataLife" name="dataLife"
                        placeholder="Enter lifespan in days" min="0" max="365" [(ngModel)]="project.lifeSpanDays"
                        (change)="checkLifeSpan()">
                    (days)
                </div>
            </div>
            <div class="help" *ngIf="specificHelpShown === 'project'">
                <button class="icon inline close" (click)="toggleSpecificHelp('project')">
                    <span class="icon icon-ui-close"></span>
                </button>
                <p>Create a new project or update an existing project.</p>
                <p>New projects must have unique names.</p>
                <p><strong>Lifespan</strong> is the number of days the promoted data will be available. The default
                    is 60 days. The maximum length is 365 days.</p>
            </div>
        </section>
        <section class="validate-options panel panel-default">
            <h4>Validate Options:</h4>
            <button class="icon inline btn btn-transparent" title="Help" (click)="toggleSpecificHelp('validate')">
                <span class="icon icon-ui-question"></span>
            </button>
            <div class="help" *ngIf="specificHelpShown === 'validate'">
                <button class="icon inline close" (click)="toggleSpecificHelp('validate')">
                    <span class="icon icon-ui-close"></span>
                </button>
                <p>
                    Once you create/select the project and are finished mapping the fields, click <strong>
                        Validate and
                        Submit to Stage
                    </strong>. If this button is not shown, check your project name and check to
                    ensure you mapped enough fields to create geometry.
                </p>
            </div>
            <div class="next-previous-buttons">
                <div class="centered-container">
                    <button type="button" class="btn red" (click)="startOver()">
                        <span class="icon icon-ui-refresh"></span>
                        Start Over
                    </button>
                    <button type="button" class="btn btn-primary btn-lg" (click)="validate()"
                            [disabled]="!enableValidateButton">
                        <span class="icon icon-ui-right-arrow"></span>
                        Validate and Submit to Stage
                    </button>
                </div>
            </div>
            <div class="service-error" *ngIf="willOverwriteScenario">
                <strong>Warning! This will delete the existing stage data.</strong>
            </div>
            <div class="error-message-container" *ngIf="createProject && projectDescriptionExistsInAnotherProject">
                <div class="service-error alert alert-danger" role="alert">
                    <strong>This project name already exists.</strong>
                </div>
            </div>
        </section>
    </div>
    <mc-petl-column-mapping-ng id="petlColumnMapping" #petlColumnMapping></mc-petl-column-mapping-ng>
</div>
